import { Box, Button, Tab, Tabs, Typography } from '@mui/material'
import React, { useState } from 'react'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';


import PointsRules from './PointsRules';
import Members from './Members';
import OverviewLoyalty from './OverviewLoyalty';
import LoyaltyRewards from './LoyaltyRewards';
import LoyaltyTiers from './LoyaltyTiers';
import { Add } from '@mui/icons-material';
import LoyaltyLogs from './LoyaltyLogs';

const Loyalty = () => {
    const [tabValue, setTabValue] = useState(0)

    const loyaltyTabs = [{
        label:
             <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                     <Typography fontSize={14} component="span">Overview</Typography>
                                 
                                </Box>
        ,
        content:
         <OverviewLoyalty/>
         
                        
         
    },
    {
      label:
     <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
        <Typography fontSize={14} component="span">Members</Typography>
                                 
      </Box>,
      content:
     
      <Members/>
      

  },
  {
      label:
     <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
        <Typography fontSize={14} component="span">Rewards</Typography>
                                 
      </Box>,
      content:
      
      <LoyaltyRewards/>
      

  },
  {
      label:
     <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
        <Typography fontSize={14} component="span">Tiers</Typography>
                                 
      </Box>,
      content:
      
      <LoyaltyTiers/>
      

  },
  {
      label:
     <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
        <Typography fontSize={14} component="span">Points Rules</Typography>
                                 
      </Box>,
      content:
      
      <PointsRules/>
      

  },
  {
      label:
     <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
        <Typography fontSize={14} component="span">Activity Log</Typography>
                                 
      </Box>,
      content:
      
      <LoyaltyLogs/>
      

  },
  
 
]
  return (
    <>


      
    <Box sx={{ m: { xs: 2, md: 4 } }}>
    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: { xs: "flex-start", sm: "center" }, flexDirection: { xs: "column", sm: "row" }, gap: 2 }}>
                <Box>
                    <Typography variant="h5" fontWeight={700}>ESTBN Loyalty Program</Typography>
                    <Typography color="text.secondary" fontSize={14}>Manage and track the performance of ESTBN Loyalty Program.</Typography>
                </Box>
                <Box display={"flex"} alignItems={"center"} gap={1}>
                 <Button  sx={{px:1.5, textTransform:"capitalize", bgcolor:"#000000", color:"#ffffff"}}>
                    <Add sx={{mx:.3}}/>
                    Create  Rule
                 </Button>
                    <button className="btn btn-light d-flex align-items-center">
                        <FileDownloadOutlinedIcon sx={{ color: "#535353", mr: 1, fontSize: 20 }} />
                        Export
                    </button>
                </Box>
            </Box>

               {/* Tabs */}
            <Box className='custom-tab-style' sx={{ borderColor: "divider" , my:2}}>
                <Tabs
                    onChange={(e, v) =>
                  setTabValue(v)
                  
                    
                 }
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={{ borderBottom: "1px solid #D8D8D8" ,  
                         }}
                    TabIndicatorProps={{ sx: { backgroundColor: "#3FBEAC", height: "3px", 
                
 } }}
                    value={tabValue}

             
                >
            {loyaltyTabs.map((t,i) => (
                 
                        <Tab
                            key={i}
                            sx={{ textTransform: "capitalize", fontSize: 14,  
                  
                 }}
                            label={
                              t.label
                            }
                        
                        />
                 
                 
                    ))}
                    
                </Tabs>
                 <Box>{loyaltyTabs[tabValue].content}</Box>
            </Box>

 

</Box>
    
    </>


)
}

export default Loyalty